export enum EFilters {
	ACTION_DATE_FROM = 'createdAtAfter',
	ACTION_DATE_TO = 'createdAtBefore',
	CAP = 'capIsReached',
	CAP_AMOUNT_FROM = 'capGte',
	CAP_AMOUNT_TO = 'capLte',
	CATEGORY = 'category',
	DATE_FROM = 'createdAfter',
	DATE_TO = 'createdBefore',
	GEO = 'country',
	MMP_LINK = 'mmpLink',
	OFFER = 'uuid',
	OFFER_ID = 'offerId',
	READ = 'read',
	CHANNEL = 'channelId',
	STATUS = 'status',
	TRAFFIC = 'trafficType',
	CHANNEL_IDS = 'channelIds',

	PLANNER_TYPE = 'plannerType',
	PLANNER_MONTH = 'plannerMonth',
	PLANNER_YEAR = 'plannerYear',
	PLANNER_DATE = 'plannerDate',

	EARNINGS_TYPE = 'earningsType',
	AGGREGATE_BY = 'aggregateBy',

	DATE_AFTER = 'dateAfter',
	DATE_BEFORE = 'dateBefore',

	PUBLISHED_AT_FROM = 'publishedAtFrom',
	PUBLISHED_AT_TO = 'publishedAtTo',

	SEARCH = 'search',
	AI_RECOMENDATION = 'ai_recomendation',
	TYPE = 'type',

	NAME = 'name',
}

export enum EFilterOptions {
	ALL = 'all',
}
